import { render, staticRenderFns } from "./BillingScopeList.vue?vue&type=template&id=e8d39dbc&scoped=true"
import script from "./BillingScopeList.vue?vue&type=script&lang=js"
export * from "./BillingScopeList.vue?vue&type=script&lang=js"
import style0 from "./BillingScopeList.vue?vue&type=style&index=0&id=e8d39dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d39dbc",
  null
  
)

export default component.exports